import css from "styled-jsx/css";
import IMAGES from "utils/constants/image";

export const styles = css`
  // -- Social

  @media (max-width: 30em) {
    .${IMAGES.USE_CASE_VIDEO}--wrapper {
      height: 20rem;
    }
  }
  @media (min-width: 30em) and (max-width: 60em) {
    .${IMAGES.USE_CASE_VIDEO}--wrapper {
      height: 16rem;
    }
  }
  @media (min-width: 60em) {
    .${IMAGES.USE_CASE_VIDEO}--wrapper {
      height: 23rem;
    }
  }

  .${IMAGES.USE_CASE_VIDEO}--img {
    background-repeat: no-repeat;
    height: 100%;
    width: 100%;
    background-image: url("/assets/${IMAGES.USE_CASE_VIDEO}.svg");
  }

  @media (max-width: 30em) {
    .${IMAGES.USE_CASE_VIDEO}--img {
      background-position: center;
    }
  }

  @media (min-width: 30em) {
    .${IMAGES.USE_CASE_VIDEO}--img {
      background-position: right;
    }
  }
`;
